import { useContext } from 'react';
import AuthContext from 'src/devias/contexts/JWTAuthContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
